import React, { useState } from "react";

const LoginForm = ({
  onSubmit,
  onForgotPassword,
  onRegister,
  logoURL,
  clientDescription,
  message,
  setMessage,
}) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);
    await onSubmit(email, password);
    setLoading(false);
  };

  const isSuccess =
    message &&
    (message.toLowerCase().includes("success") ||
      message.toLowerCase().includes("ok"));

  return (
    <div className="inner-form-container">
      <h2>{clientDescription}</h2>
      <img
        src={
          logoURL
            ? `${logoURL}`
            : "https://placehold.co/250x250/png"
        }
        alt="Brand Logo"
        className="branding-image"
      />
      <h2>Login</h2>

      {message && (
        <div className={isSuccess ? "success-box" : "error-box"}>{message}</div>
      )}

      <form onSubmit={handleFormSubmit} className="form">
        <label className="label">
          Email:
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input"
            placeholder="you@example.com"
          />
        </label>

        <label className="label">
          Password:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="input"
            placeholder="Your password"
          />
        </label>

        <button
          type="submit"
          className={`login-button ${loading ? "loading" : ""}`}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Log In"}
        </button>
        <button type="button" onClick={onRegister} className="register-button">
          Register For Online?
        </button>
      </form>

      <p
        className="forgot-password"
        onClick={onForgotPassword}
        tabIndex={0}
        role="button"
      >
        Forgot password?
      </p>
    </div>
  );
};

export default LoginForm;
